export const SourceMro = "mros";

export const TitleMro = { list: "MRO List", edit: "Edit MRO", create: "Create MRO" };
